import GroupWithPurchaserRecord from "models/view-models/group-with-purchaser-record";
import DataTable from "organisms/data-tables/data-table";
import React from "react";
import { CollectionUtils } from "utilities/collection-utils";
import { t } from "utilities/localization-utils";

export interface TeamResultsTableProps {
    teams: Array<GroupWithPurchaserRecord>;
    selectedTeamId: number | undefined;
    onTeamClick: (teamId: number | undefined) => void;
}

const CSS_BASE_CLASS = "c-support-admin-dashboard-table";

const TeamResultsTable: React.FC<any> = (props: TeamResultsTableProps) => {
    const { teams, selectedTeamId, onTeamClick } = props;

    const handleClick = (teamId: number) => {
        teamId === selectedTeamId
            ? onTeamClick(undefined)
            : onTeamClick(teamId);
    };

    return (
        <DataTable cssClassName={CSS_BASE_CLASS}>
            <thead>
                <tr>
                    <th>{t("owner")}</th>
                    <th>{t("team-name")}</th>
                    <th>{t("team-size")}</th>
                    <th>{t("subscription")}</th>
                </tr>
            </thead>
            <tbody>
                {CollectionUtils.isNotEmpty(teams) ? (
                    teams.map((team: GroupWithPurchaserRecord) => {
                        return (
                            <tr
                                className={`${CSS_BASE_CLASS}__row ${team.id && selectedTeamId === team.id ? "-selected" : ""}`}
                                key={team.id}
                                onClick={() => handleClick(team.id!)}>
                                <td>
                                    {team.groupPurchaser?.fullName} (
                                    {team.groupPurchaser?.email})
                                </td>
                                <td>
                                    {team.name}{" "}
                                    {team.isExpired ? "(Expired)" : ""}
                                </td>
                                <td>{team.numberOfMembers}</td>
                                <td>{team.subscriptionType}</td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={4} className="-no-results-row">
                            No results found - please try adjusting your search.
                        </td>
                    </tr>
                )}
            </tbody>
        </DataTable>
    );
};

export default TeamResultsTable;
